(function() {
  'use strict';

  var registry = window.PooleaseSectionScripts = window.PooleaseSectionScripts || {};

  function initSection(section) {
    if (!section || section.dataset.productFaqReady === 'true') return;
    section.dataset.productFaqReady = 'true';
    var toggles = section.querySelectorAll('[data-faq-toggle]');
    toggles.forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        var item = this.closest('.product-faq__item');
        var isOpen = item.classList.contains('is-open');
        var answer = item.querySelector('.product-faq__answer');
        item.classList.toggle('is-open');
        this.setAttribute('aria-expanded', String(!isOpen));
        if (answer) {
          answer.setAttribute('aria-hidden', String(isOpen));
          answer.toggleAttribute('inert', isOpen);
        }
      });
    });
  }

  function initAll(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('.product-faq')) initSection(scope);
    var sections = scope.querySelectorAll ? scope.querySelectorAll('.product-faq') : [];
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
  }

  if (registry.productFaq) {
    registry.productFaq(document);
    return;
  }
  registry.productFaq = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function(event) { initAll(event.target); });
})();
